import { render } from "./ModalNuovoInterventoFromTicket.vue?vue&type=template&id=dec799b8&scoped=true"
import script from "./ModalNuovoInterventoFromTicket.vue?vue&type=script&lang=js"
export * from "./ModalNuovoInterventoFromTicket.vue?vue&type=script&lang=js"

import "./ModalNuovoInterventoFromTicket.vue?vue&type=style&index=0&id=dec799b8&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_gm-system_1764364635178909029/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dec799b8"]])

export default __exports__